import React from 'react';
import { Hero, Steps, ValueProposition } from './components';
import { Footer } from '../../components/Footer';

export function WordpressScreen() {
  return (
    <div>
      <Hero />
      <Steps />
      <ValueProposition />
      <Footer />
    </div>
  );
}
